import React from 'react';
import PropTypes from "prop-types";
import {Button, FormGroup, Label, Toast, Loading, Input} from "spectre-react/dist/cjs";
import {getReportNotes, postReportNotes} from '../../api';


class ModalNotes extends React.PureComponent {
    static propTypes = {
        onSubmit: PropTypes.func,
    }

    getDefaultState() {
        return {
            isOpened: false,
            fetchState: 0, fetchError: undefined,
            submitState: 0, submitError: undefined,
            reportId: undefined, notes: ""
        };
    }

    state = this.getDefaultState();

    open = async (reportId) => {
        this.setState({ isOpened: true, fetchState: 1, fetchError: undefined, reportId });

        try {
            const { notes } = await getReportNotes(reportId);
            this.setState({ fetchState: 2, fetchError: undefined, notes: notes ?? "" });
        } catch (error) {
            this.setState({ fetchState: 0, fetchError: error.message });
        }
    };

    close = () => this.setState(this.getDefaultState());

    onChange = (ev) => this.setState({ notes: ev.target.value, submitError: undefined });

    submit = async () => {
        this.setState({ submitState: 1, submitError: undefined });

        try {
            const { reportId, notes } = this.state;
            await postReportNotes(reportId, notes);

            this.setState({ submitState: 2, submitError: undefined });

            this.close();
        } catch (error) {
            this.setState({ submitState: 0, submitError: error.message })
        }
    };

    render() {
        const {
            isOpened,
            fetchState, fetchError,
            submitState, submitError,
            notes
        } = this.state;

        if (!isOpened)
            return null;

        const isFetching = fetchState === 1;
        const isSubmitting = submitState === 1;

        return (
            <div className="modal active" id="report-notes-modal">
                <span className="modal-overlay" onClick={this.close}/>
                <div className="modal-container modal-fullheight">
                    <div className="modal-header">
                        <button type="button" className="btn btn-clear float-right" onClick={this.close}/>
                        <div className="modal-title h5">Заметки</div>
                    </div>

                    <div className="modal-body">
                        {fetchState !== 2 && <Loading large />}
                        {fetchError && <Toast error className="mb-2">{fetchError}</Toast>}

                        {fetchState === 2 && (
                            <FormGroup>
                                <Label form>Комментарий</Label>
                                <Input renderAs="textarea" name="notes" onChange={this.onChange} value={notes}/>
                            </FormGroup>
                        )}
                    </div>

                    <div className="modal-footer">
                        {submitError && <Toast error className="mb-2">{submitError}</Toast>}

                        <Button primary loading={isFetching || isSubmitting} onClick={this.submit} disabled={fetchState !== 2}>Отправить</Button>
                        <Button link className="ml-2" onClick={this.close}>Закрыть</Button>
                    </div>
                </div>
            </div>
        )
    }
}


export default ModalNotes;